import { render, staticRenderFns } from "./UploadMessageDialog.vue?vue&type=template&id=24845d82"
import script from "./UploadMessageDialog.vue?vue&type=script&lang=js"
export * from "./UploadMessageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports